var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.8C8.25 3.70132 9.92893 2 12 2C14.0711 2 15.75 3.70132 15.75 5.8V6.81333H17.9299C19.1765 6.81333 20.1402 7.8844 19.9832 9.0953L18.669 19.2286C18.5377 20.2411 17.6581 21 16.6158 21H7.38425C6.34194 21 5.46225 20.2411 5.33095 19.2286L4.0168 9.0953C3.85977 7.8844 4.82351 6.81333 6.0701 6.81333H8.25V5.8ZM12 3.52C10.7574 3.52 9.75 4.54079 9.75 5.8V6.81333H14.25V5.8C14.25 4.54079 13.2426 3.52 12 3.52ZM16.5303 11.5303C16.8232 11.2374 16.8232 10.7626 16.5303 10.4697C16.2374 10.1768 15.7626 10.1768 15.4697 10.4697L11 14.9393L9.53033 13.4697C9.23744 13.1768 8.76256 13.1768 8.46967 13.4697C8.17678 13.7626 8.17678 14.2374 8.46967 14.5303L10.4697 16.5303C10.6103 16.671 10.8011 16.75 11 16.75C11.1989 16.75 11.3897 16.671 11.5303 16.5303L16.5303 11.5303Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag11);
export default __webpack_public_path__ + "static/media/shopping-bag-11.51cd78b59155a6b46d1f02bb41157b7f.svg";
export { ForwardRef as ReactComponent };